import { flashError, flashSuccess } from "./flash";

function statusSelectColor(data, container) {
  if (data.element) {
    $(container).addClass(data.element.dataset.classname);
  }
  return data.text;
}

function disableContainerAndBookingSelect(_e) {
  const containerSelect = $("#task_container_id");
  const bookingSelect = $("#task_booking_id");

  const taskTypeId = $("#task_task_type_id").val();
  const taskType = JSON.parse($("#task_types").val()).find((x) => x.id == taskTypeId);

  if (taskType && taskType.booking_level) {
    bookingSelect.prop("disabled", false);
    bookingSelect.prop("required", true);
  } else {
    bookingSelect.val("");
    bookingSelect.prop("disabled", true);
    bookingSelect.prop("required", false);
  }
  if (taskType && taskType.container_level) {
    containerSelect.prop("disabled", false);
    containerSelect.prop("required", true);
  } else {
    containerSelect.val("");
    containerSelect.prop("disabled", true);
    containerSelect.prop("required", false);
  }
}

function getDueDate(_e) {
  const shipmentId = $("#task_shipment_id").val();
  const taskTypeId = $("#task_task_type_id").val();

  if (!shipmentId || !taskTypeId) {
    return null;
  }
  $.ajax({
    method: "GET",
    url: "/admin/tasks/calculate_dates",
    dataType: "JSON",
    data: {
      shipment_id: shipmentId,
      task_type_id: taskTypeId,
    },
    error: () => flashError("Something went wrong!"),
    success: (data) => {
      $("#task_due_date").val(data.due_date);
      $("#task_start_date").val(data.start_date);
    },
  });
}

function updateCollaborators() {
  const shipmentId = $("#task_shipment_id").val();

  let collaboratorsSelect = $("#task_organization_ids");
  collaboratorsSelect.empty();

  if (shipmentId) {
    $.ajax({
      method: "GET",
      url: `/admin/shipments/${shipmentId}/organizations`,
      dataType: "JSON",
      error: () => {
        flashError("Something went wrong!");
      },
      success: (data) => {
        data.forEach((x) => {
          collaboratorsSelect.append(`<option value=${x.id}>${x.name}</option>`);
        });
      },
    });
  }
}

$(document).on("turbolinks:load", () => {
  $(".task-status-select").select2({
    templateResult: statusSelectColor,
    templateSelection: statusSelectColor,
  });
});

$(document).on("change", "#task_shipment_id", getDueDate);
$(document).on("change", "#task_task_type_id", getDueDate);
$(document).on("change", "#task_task_type_id", disableContainerAndBookingSelect);
$(document).on("click", ".task-description-submit", (e) => {
  let input = $(e.target).parents(".input-group").find(".task-description");
  $.ajax({
    method: "PATCH",
    dataType: "JSON",
    url: `/admin/tasks/${input.attr("id")}`,
    data: {
      task: {
        description: input.val(),
        updated_by_id: input.data().currentUserId,
      },
    },
    error: () => flashError("Something went wrong!"),
    success: () => flashSuccess("Task description has been updated!"),
  });
});

$(document).on("change", "#task_shipment_id", updateCollaborators);
